import React from "react";
import styles from "./GallerySection.module.css";

interface GallerySectionProps {
  gallery?: string[];
}

const GallerySection: React.FC<GallerySectionProps> = ({ gallery }) => {
  return (
    <div className={styles.galleryContainer}>
      <h3 className={styles.title}>نمونه کارها</h3>

      <div className={styles.gallery}>
        {gallery && gallery.length > 0 ? (
          gallery.map((image, index) => (
            <div key={index} className={styles.imageContainer}>
              <img src={image} alt={`Sample ${index + 1}`} className={styles.image} />
            </div>
          ))
        ) : (
          <p className={styles.emptyMessage}>نمونه‌کاری ثبت نشده است.</p>
        )}
      </div>

      <div className={styles.divider}></div>
    </div>
  );
};

export default GallerySection;
